import Bottom from './Bottom'
import Top from './Top'
import {
  Logo,
  Sidebar
} from '@eggplant/pattern-library'
import { PreferencesConsumer } from '@eggplant/context'
import {
  collapseWidth,
  expandWidth,
  logoWrapperStyle,
  sideNavwrapperStyle
} from './styles'

const SideNav = () =>
  <PreferencesConsumer>
    {
      ({
        isNavCollapsed: isCollapsed,
        setIsNavCollapsed
      }) =>
        <Sidebar
          isCollapsed={isCollapsed}
          onCollapse={setIsNavCollapsed}
        >
          <div
            style={
              {
                ...sideNavwrapperStyle,
                width: isCollapsed
                  ? collapseWidth
                  : expandWidth
              }
            }
          >
            <div>
              <div style={logoWrapperStyle}>
                <Logo isCollapsed={isCollapsed} />
              </div>
              <Top isCollapsed={isCollapsed} />
            </div>
            <div>
              <Bottom isCollapsed={isCollapsed} />
            </div>
          </div>
        </Sidebar>
    }
  </PreferencesConsumer>

export default SideNav
